<template>
  <validation-provider #default="{ errors, valid }" :name="inputLabel" :vid="inputLabel" :rules="customRules"
    :custom-messages="customMessages">
    <BFormGroup :state="errors.length > 0 ? false : null" :label="inputLabel" :label-for="inputId">
      <BInputGroup :state="false" class="input-group-merge border-none w-auto">
        <BFormInput :size="size" :readonly="readonly" :formatter="formatter" :state="errors.length > 0 ? false : null"
          :type="type" :disabled="disabled" trim :id="inputId" :value="value" class="d-inline-block"
          :placeholder="inputPlaceholder" :inputmode="inputMode" :class="$scopedSlots['append'] ? 'border-right' : ''"
          @input="filterInputValue" @keydown="preventInvalidKeys" />



        <template v-if="$scopedSlots['append']">
          <BInputGroupAppend class="rounded-right" :class="errors.length > 0
            ? 'custom-text-input border-danger'
            : 'border-none'
            " is-text>
            <slot name="append"> </slot>
          </BInputGroupAppend>
        </template>
      </BInputGroup>
      <small class="mt-2 text-danger" v-if="errorMessage">
        {{ errorMessage }}
      </small>
      <small class="mt-2 text-danger" v-if="errors && errors.length > 0">
        {{ errors[0] }}
      </small>
    </BFormGroup>
  </validation-provider>
</template>

<script>
export default {
  emits: ["enter"],
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    formatter: {
      type: Function,
      default: (value) => value,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: [Boolean, null],
      default: false,
    },
    errorMessage: {
      type: [String, null],
      default: null,
    },
    customRules: {
      type: [String, null],
      default: null,
    },
    inputId: {
      type: String,
      required: false,
      default: "textValue",
    },
    size: {
      type: String,
      required: false,
      default: "medium",
    },
    value: {
      type: [String, Number, null],
      default: null,
    },
    inputLabel: {
      type: [String, null],
      default: "وارد کنید",
    },
    inputPlaceholder: {
      type: [String, null],
      default: "وارد کنید",
    },
    type: {
      type: String,
      default: "text",
    },
    inputMode: {
      type: String,
      default: "text",
    },
    numberOnly: {
      type: Boolean,
      default: false
    },
    min: {
      type: Number,
      default: null
    },
    max: {
      type: Number,
      default: null
    },
    customMessages: {
      type: Object,
      default: () => {
        return {
          required: "{_field_} اجباری است",
          min: "{_field_} حداقل باید {length} حرف باشد",
          max: "{_field_} حداکثر باید {length} حرف باشد",
          between: "{_field_} باید بین {min} و {max} باشد",
        };
      },
    },
  },
  data() {
    return {
      required,
    };
  },
  methods: {
    emitEnterKeydown() {
      this.$emit("enter");
    },




    filterInputValue(val) {
      let newVal = val;

      if (this.numberOnly) {

        newVal = newVal.replace(/[^0-9.]/g, "");


        const parts = newVal.split(".");
        if (parts.length > 2) {
          newVal = parts[0] + "." + parts[1];
        }


        if (newVal !== "" && !isNaN(newVal)) {
          const numVal = parseFloat(newVal);

          if (this.min !== null && numVal < this.min) {
            newVal = String(this.min);
          }
          if (this.max !== null && numVal > this.max) {
            newVal = String(this.max);
          }
        }
      }

      this.$emit("input", newVal);
    },

    preventInvalidKeys(e) {
      if (!this.numberOnly) return;

      const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
      if (allowedKeys.includes(e.key)) return;


      if (e.key === ".") {
        if (this.value && this.value.includes(".")) {
          e.preventDefault();
        }
        return;
      }


      if (["e", "E", "+", "-"].includes(e.key)) {
        e.preventDefault();
        return;
      }


      if (isNaN(e.key) && e.key.length === 1) {
        e.preventDefault();
        return;
      }


      if (this.max !== null && e.key >= "0" && e.key <= "9") {
        const current = this.value ?? "";
        let nextVal;


        if (e.target.selectionStart != null) {
          const start = e.target.selectionStart;
          const end = e.target.selectionEnd;
          nextVal = current.slice(0, start) + e.key + current.slice(end);
        } else {
          nextVal = current + e.key;
        }


        const parts = nextVal.split(".");
        if (parts.length > 2) {
          e.preventDefault();
          return;
        }


        if (parts.length === 2 && parts[1].length > 1) {
          e.preventDefault();
          return;
        }


        if (!nextVal.endsWith(".")) {
          let numVal = parseFloat(nextVal);

          if (!isNaN(numVal)) {
            if (numVal > this.max) {
              const divided = numVal / 10;

              if (divided <= this.max) {

                e.preventDefault();
                this.$emit("input", String(divided));
              } else {

                e.preventDefault();
              }
            }
          }
        }
      }
    }






  },
  components: {
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
  },
};
import {
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
} from "bootstrap-vue";
import { required } from "@validations";
import { ValidationProvider } from "vee-validate";
</script>
<style>
.custom-text-input .input-group-text {
  border: none !important;
}
</style>
